// import axios from 'axios';
// import { toastText } from 'utils/utils';
// import { createBrowserHistory } from 'history';

// const history = createBrowserHistory();
// const endPoint = process.env.REACT_APP_API_ENDPOINT;

// const apiConfig = (flag = false) => {
// 	if (localStorage.getItem('accessToken')) {
// 		return {
// 			headers: {
// 				Authorization: `bearer ${localStorage.getItem('accessToken')}`,
// 				'Content-Type': flag
// 					? 'multipart/form-data'
// 					: 'application/json',
// 			},
// 			method: 'PUT,DELETE,POST,GET,OPTION',
// 		};
// 	}
// 	return { withCredentials: false };
// };

// axios.interceptors.response.use(
// 	(response) => response,
// 	(error) => {
// 		console.log('Error: ', error);
// 		if (error.response && error.response.status === 401) {
// 			// toastText("ur acess is removed", 'error');
// 			localStorage.removeItem('accessToken');

// 			// Delay navigation to allow toast to show
// 			setTimeout(() => {
// 				history.push('/login');
// 			}, 1500); // 1.5s delay
// 		}
// 		return Promise.reject(error);
// 	}
			

// );

// export const getApi = (url?: string, params?: any) => {
// 	return axios.get(`${endPoint}${url}`, {
// 		params: params,
// 		...apiConfig(),
// 	});
// };

// export const postApi = (url: string, apiData?: any, flag?: boolean) => {
// 	return axios.post(`${endPoint}${url}`, apiData, apiConfig(flag));
// };

// export const putApi = (url: string, apiData: any, flag?: boolean) => {
// 	return axios.put(`${endPoint}${url}`, apiData, apiConfig(flag));
// };

// export const deleteApi = (url: string) => {
// 	return axios.delete(`${endPoint}${url}`, apiConfig());
// };

// export const deleteApiWithData = (url: string, apiData?: any) => {
// 	return axios.delete(`${endPoint}${url}`, {
// 		data: apiData,
// 		...apiConfig(),
// 	});
// };

// export const putApiNoHeader = (url: string, apiData: any) => {
// 	if (localStorage.getItem('accessToken')) {
// 		return axios.put(`${endPoint}${url}`, apiData, {
// 			headers: {
// 				Authorization: `bearer ${localStorage.getItem('accessToken')}`,
// 			},
// 		});
// 	} else {
// 		// If there's no access token, return an error response or handle it as needed.
// 		return Promise.reject('No access token available');
// 	}
// };

// export const getApiExcel = async (url?: string, params?: any) => {
// 	const configData = await apiConfig();
// 	return axios.get(`${endPoint}${url}`, {
// 		params: params,
// 		responseType: 'arraybuffer',
// 		...configData,
// 	});
// };

// export const getApiPDF = async (url?: string, params?: any) => {
// 	const configData: any = await apiConfig();
// 	configData.headers['responseType'] = 'blob';
// 	return axios.get(`${endPoint}${url}`, {
// 		params: params,
// 		...configData,
// 	});
// };

// export const getApiCSV = async (url?: string, params?: any) => {
// 	const configData = await apiConfig();
// 	return axios.get(`${endPoint}${url}`, {
// 		params: params,
// 		responseType: 'arraybuffer',
// 		...configData,
// 	});
// };


import axios from 'axios';
const endPoint = process.env.REACT_APP_API_ENDPOINT;

const apiConfig = (flag = false) => {
	if (localStorage.getItem('accessToken')) {
		return {
			headers: {
				Authorization: `bearer ${localStorage.getItem('accessToken')}`,
				'Content-Type': flag
					? 'multipart/form-data'
					: 'application/json',
			},
			method: 'PUT,DELETE,POST,GET,OPTION',
		};
	}
	return { withCredentials: false };
};

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 401) {
			localStorage.removeItem('accessToken');

			// Delay navigation to allow toast to show
			setTimeout(() => {
				window.location.href = '/login';
			}, 1500);
		}
		return Promise.reject(error);
	}


);

export const getApi = async (url?: string, params?: any) => {
	try {
		return await axios.get(`${endPoint}${url}`, {
			params: params,
			...apiConfig(),
		});
	} catch (error) {
		return Promise.reject(error);
	}
};

export const postApi = async (url: string, apiData?: any, flag?: boolean) => {
	try {
		return await axios.post(`${endPoint}${url}`, apiData, apiConfig(flag));
	} catch (error) {
		return Promise.reject(error);
	}
};

export const putApi = async (url: string, apiData: any, flag?: boolean) => {
	try {
		return await axios.put(`${endPoint}${url}`, apiData, apiConfig(flag));
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteApi = async (url: string) => {
	try {
		return await axios.delete(`${endPoint}${url}`, apiConfig());
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteApiWithData = async (url: string, apiData?: any) => {
	try {
		return await axios.delete(`${endPoint}${url}`, {
			data: apiData,
			...apiConfig(),
		});
	} catch (error) {
		return Promise.reject(error);
	}
};

export const putApiNoHeader = async (url: string, apiData: any) => {
	if (localStorage.getItem('accessToken')) {
		try {
			return await axios.put(`${endPoint}${url}`, apiData, {
				headers: {
					Authorization: `bearer ${localStorage.getItem('accessToken')}`,
				},
			});
		} catch (error) {
			return Promise.reject(error);
		}
	} else {
		// If there's no access token, return an error response or handle it as needed.
		return Promise.reject('No access token available');
	}
};
